/**
 * @typedef {import("../store/store").StoreApp} StoreApp
 */

/**
 *
 * @param {StoreApp} state
 * @returns {StoreApp['auth']}
 */
export const authSelector = (state) => state.auth;

/**
 *
 * @param {StoreApp} state
 * @returns {StoreApp['auth']['user']}
 */
export const authUserSelector = (state) => state.auth.user;
